import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ListChecks } from "lucide-react";
import { api } from "@/lib/api";

/** Teller 'Mijn taken' in de bovenbalk: open taken voor vandaag + te laat (rood als er iets te laat is). */
export function MijnTakenBadge() {
  const nav = useNavigate();
  const [t, setT] = useState(null);
  useEffect(() => {
    const laad = () => api.get("/taken/mijn-teller", { bptStil: true }).then(({ data }) => setT(data)).catch(() => {});
    laad();
    const iv = setInterval(laad, 60000);
    window.addEventListener("bpt:taken-gewijzigd", laad);
    return () => { clearInterval(iv); window.removeEventListener("bpt:taken-gewijzigd", laad); };
  }, []);
  const n = t?.totaal || 0;
  const titel = t ? `${t.vandaag} vandaag · ${t.te_laat} te laat` : "Mijn taken";
  return (
    <button type="button" className="v3-taken" onClick={() => nav("/taken?tab=mijn")} title={titel} aria-label={`Mijn taken: ${titel}`} data-testid="v3-mijn-taken">
      <ListChecks />
      <span className="v3-hide-m">Mijn taken</span>
      <span className={`v3-badge${t?.te_laat ? " laat" : ""}${n ? "" : " nul"}`} data-testid="v3-mijn-taken-teller">{n > 99 ? "99+" : n}</span>
    </button>
  );
}
